import { createStyles } from "@envestnet/envreact-component-library";
import type { WithStyles } from "@envestnet/envreact-component-library";

const styles = () =>
  createStyles({
    container: {},
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
